import styled from 'styled-components';

export const ViewContainer = styled.div`
  margin-top: 20px;
  width: 500px;
`;

export const RulesAndRewardsViewContainer = styled.div``;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 40px;
`;

export const NextRoundButton = styled.div<{ disabled: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  padding: 10px 20px;
  border-radius: 16px;
  font-weight: 700;
  cursor: pointer;
  gap: 10px;
  border: ${({ disabled }) =>
    disabled ? '2px solid #D0D2D8' : '2px solid var(--fi-accent, #FF6A00)'};
  color: ${({ disabled }) =>
    disabled ? '#D0D2D8' : 'var(--fi-accent, #FF6A00)'};
`;

export const NextRoundIcon = styled.img`
  width: 20px;
  height: 20px;
`;
